import _ from 'lodash';
import { 
  GET_POWER_BI_ACCESSES, 
  GET_POWER_BI_ACCESS,
  CREATE_POWER_BI_ACCESS,
  UPDATE_POWER_BI_ACCESS,
  DISABLE_POWER_BI_ACCESS,
  ENABLE_POWER_BI_ACCESS,
  GET_ACCESS_TYPES,
  GET_BANNER_PROGRAMS,
  GET_BANNER_FACULTIES,
  GET_BANNER_DEPARTMENTS
} from '../actions/powerBiAccessesActions';

/**
 * Manejo de la parte del estado correspondiente a permisos de Power BI.
 * Permite la actualización de permisos, obtener un permiso por id, además de obtener los permisos
 * con paginación.
 * Permite crear, actualizar, eliminar y habilitar permisos.
 *
 * @export
 * @param {*} [state={}] : estado de la aplicación
 * @param {*} action : operación a realizar sobre el estado (correspondiente a los permisos)
 * @returns El estado con la modificación/acción realizada.
 */
export default function (state = {}, action) {
  switch (action.type) {
    case GET_POWER_BI_ACCESSES:
      const accessesData = action.payload.power_bi_accesses || action.payload.powerBiAccesses || [];
      const accesses = _.mapKeys(accessesData, 'id');
      const pagination = action.payload.links;
      return { ...state, accesses: accesses, pagination: pagination };
    
    case GET_POWER_BI_ACCESS:
      const access = action.payload.power_bi_access || action.payload.powerBiAccess;
      return { ...state, access: access, [access.id]: access };
    
    case CREATE_POWER_BI_ACCESS:
      const newAccess = action.payload.power_bi_access || action.payload.powerBiAccess;
      return { ...state, [newAccess.id]: newAccess };
    
    case UPDATE_POWER_BI_ACCESS:
      const updatedAccess = action.payload.power_bi_access || action.payload.powerBiAccess;
      return { ...state, [updatedAccess.id]: updatedAccess };
    
    case DISABLE_POWER_BI_ACCESS:
      const accessId = action.payload;
      const updatedAccesses = { ...state.accesses };
      if (updatedAccesses[accessId]) {
        updatedAccesses[accessId] = {
          ...updatedAccesses[accessId],
          disabled: true
        };
      }
      return { ...state, accesses: updatedAccesses };
    
    case ENABLE_POWER_BI_ACCESS:
      const enabledAccess = action.payload.power_bi_access || action.payload.powerBiAccess;
      const updatedAccessesForEnable = { ...state.accesses };
      if (enabledAccess && enabledAccess.id) {
        updatedAccessesForEnable[enabledAccess.id] = enabledAccess;
      }
      return { 
        ...state, 
        [enabledAccess.id]: enabledAccess,
        accesses: updatedAccessesForEnable
      };
    
    case GET_ACCESS_TYPES:
      const accessTypes = action.payload.access_types || action.payload.accessTypes;
      return { ...state, accessTypes: accessTypes };
    
    case GET_BANNER_PROGRAMS:
      const bannerPrograms = action.payload.banner_programs || action.payload.bannerPrograms || [];
      return { ...state, bannerPrograms: bannerPrograms };
    
    case GET_BANNER_FACULTIES:
      const bannerFaculties = action.payload.banner_faculties || action.payload.bannerFaculties || [];
      return { ...state, bannerFaculties: bannerFaculties };
    
    case GET_BANNER_DEPARTMENTS:
      const bannerDepartments = action.payload.banner_departments || action.payload.bannerDepartments || [];
      return { ...state, bannerDepartments: bannerDepartments };
    
    default:
      return state;
  }
}

